import styled, { css } from 'styled-components';

export const Cart = styled.div`
  ${({ informationalUse }) => !informationalUse && css`
    padding: 10px var(--grid-margin-space) 30px var(--grid-margin-space);
  `}
`;
